import React, { useState } from 'react';
import { X, Upload, Loader2 } from 'lucide-react';
import { uploadStory } from '../services/StoryService';
import './StoryUploadModal.css';

const StoryUploadModal = ({ user, onClose, onUploadSuccess }) => {
    const [file, setFile] = useState(null);
    const [preview, setPreview] = useState(null);
    const [isUploading, setIsUploading] = useState(false);

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile) {
            setFile(selectedFile);
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreview(reader.result);
            };
            reader.readAsDataURL(selectedFile);
        }
    };

    const handleUpload = async () => {
        if (!file || !user) return;

        setIsUploading(true);
        try {
            await uploadStory(user, file);
            onUploadSuccess();
        } catch (error) {
            console.error("Upload failed:", error);
            alert("Failed to upload story. Please try again.");
        } finally {
            setIsUploading(false);
        }
    };

    return (
        <div className="modal-overlay">
            <div className="story-upload-container">
                <div className="modal-header">
                    <h3>Post Story</h3>
                    <button onClick={onClose} className="close-btn">
                        <X size={24} />
                    </button>
                </div>

                <div className="upload-content">
                    {!preview ? (
                        <label className="file-dropzone">
                            <input
                                type="file"
                                accept="image/*,video/*"
                                onChange={handleFileChange}
                                hidden
                            />
                            <div className="dropzone-content">
                                <Upload size={48} color="var(--primary)" />
                                <p>Select an image or video</p>
                                <span>Stories last for 24 hours</span>
                            </div>
                        </label>
                    ) : (
                        <div className="preview-container">
                            {file.type.startsWith('video') ? (
                                <video src={preview} controls className="preview-media" />
                            ) : (
                                <img src={preview} alt="Preview" className="preview-media" />
                            )}
                            <button
                                className="change-file-btn"
                                onClick={() => { setFile(null); setPreview(null); }}
                            >
                                Change File
                            </button>
                        </div>
                    )}
                </div>

                <div className="modal-footer">
                    <button
                        className="post-btn"
                        disabled={!file || isUploading}
                        onClick={handleUpload}
                    >
                        {isUploading ? (
                            <><Loader2 className="animate-spin" size={20} /> Uploading...</>
                        ) : (
                            'Post Now'
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default StoryUploadModal;
